import withInputFields from "../../helpers/inputfields";
import { getValueAtPath, withProperties } from "../../../../utils";
import { USES_CHARGE_POLLING } from "../../../../charge/flags";
import getChargeLimit from "../../../../lookup/limit";
import getChargeFee from "../../../../lookup/fee";

import InitView from "./views/init";
import ConfirmView from "./views/confirm";
import withReactiveFields from "../../helpers/reactivefields";

const METHOD = 'fawrypay';
const METHOD_NAME = 'Fawry';
const CHARGE_MODE = USES_CHARGE_POLLING;

const VIEWS = [ InitView, ConfirmView ];

function mount() {
  return (dispatch) => {
    // Some logic here to determine the view to show instead of
    // always showing the form (first) view, nd also other stuffs
    // like fee check, limit check, etc.
    getChargeLimit.call(this, () => {
      const VIEW = (
        this.FAWRY_REFERENCE && (ConfirmView || this.$resetContext())
      ) || InitView;
      
      VIEW && VIEW.activate.call(this);
    });

    getChargeFee();
  };
}

function getChargeData() {
  return ({
    country: 'EG',
    currency: 'EGP',
    network: 'MTN',
    payment_type: 'fawry_pay'
  });
}

function getViewsContext(data, store) {
  const $context = withReactiveFields(Object.create(null), 'FAWRY_REFERENCE');

  withInputFields($context, {
    phone: getValueAtPath(data, 'phone') || null
  });

  $context.$subscribe('FAWRY_REFERENCE', (currentValue, oldValue) => {
    setTimeout(() => {
      if (!(oldValue || oldValue === currentValue) && currentValue) {
        ConfirmView && ConfirmView.activate();
      }
    }, 0)
  });

  return withProperties($context, {
    $resetContext() {
      $context.FAWRY_REFERENCE = null;
    },

    INIT_VIEW: callback => {
      $context.$resetContext(),
      InitView && InitView.activate(callback);
    }
  });
}

export {
  METHOD,
  METHOD_NAME,
  CHARGE_MODE,
  VIEWS,
  mount,
  getChargeData,
  getViewsContext
}
